/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const ArrowRight: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0581 5.55806C13.3021 5.31398 13.6979 5.31398 13.9419 5.55806L19.9419 11.5581C20.186 11.8021 20.186 12.1979 19.9419 12.4419L13.9419 18.4419C13.6979 18.686 13.3021 18.686 13.0581 18.4419C12.814 18.1979 12.814 17.8021 13.0581 17.5581L17.9911 12.625H5.5C5.15482 12.625 4.875 12.3452 4.875 12C4.875 11.6548 5.15482 11.375 5.5 11.375H17.9911L13.0581 6.44194C12.814 6.19786 12.814 5.80214 13.0581 5.55806Z"
      fill={color}
    />
  </svg>
)
